export default class ClientScript {
  constructor(axios, cmsUrl) {
    this.$axios = axios;
    this.cmsUrl = cmsUrl;
  }

  loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = "text/javascript";
      script.src = src;
      script.onload = () => resolve(script);
      script.onerror = () => reject(new Error(`Script load error for: ${src}`));
      document.head.appendChild(script);
    });
  }

  async loadScripts() {
    try {
      const clientScriptsResponse = await this.$axios.get(`${this.cmsUrl}frontend-scripts/scripts`);

      if (typeof clientScriptsResponse.data === "string") {
        const scriptSources = clientScriptsResponse.data.matchAll(/src=\"(?<src>.*)\"/g);

        for (const scriptSource of scriptSources) {
          if (!!scriptSource.groups?.src) {
            this.loadScript(scriptSource.groups?.src);
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async injectDomObject(name, object) {
    if (typeof name === "string" && object) {
      window[name] = object;
    }
  }
}
